import { useMemo } from "react";
import { useGrpcClient, usePropertyGrpcCall } from "../../../../lib/grpc";
import { InventoryAPIPromiseClient } from "../../../../gen/witbooking/backoffice/inventory/v1/inventory_api_grpc_web_pb";
import {
  CreateInventoryLinesRequest,
  InventoryLineErrorCode,
  InventoryLineValueType,
} from "../../../../gen/witbooking/backoffice/inventory/v1/inventory_api_pb";
import { BatchInventoryEntity } from "../../domain/BatchInventory.entity";

export function useInventoryApi() {
  const grpcClient = useGrpcClient(InventoryAPIPromiseClient);
  const createInventoryLines = usePropertyGrpcCall(grpcClient, grpcClient.createInventoryLines);

  return useMemo(
    () => ({
      getInventoryLineValueType: (valueType: InventoryLineValueType) => {
        return Object.keys(InventoryLineValueType)[valueType];
      },
      getInventoryLineErrorCode: (errorCode: InventoryLineErrorCode) => {
        return Object.keys(InventoryLineErrorCode)[errorCode];
      },
      createInventoryLines: async (values: BatchInventoryEntity) => {
        const request = new CreateInventoryLinesRequest();
        request.setAccommodationsList(values.accommodations);
        request.setConfigurationsList(values.occupations);
        request.setMealPlansList(values.mealPlans);
        request.setConditionsList(values.conditions);

        const response = await createInventoryLines(request);
        return response.toObject();
      },
    }),
    [createInventoryLines]
  );
}
